import { DepartmentCostSummary, Team } from '@internal/schemas-common';

import { CostStackedBarChart } from '../../costStackedBarChart/CostStackedBarChart';
import { Grid } from '@material-ui/core';
import { Header } from '../../header/Header';
import { InfoCard } from '@backstage/core-components';
import { createDatadogUrl } from '../../../helpers/datadogUrl';

interface CostScoreCardDepartmentDetailViewProps {
  teams: Team[];
  costSummary: DepartmentCostSummary;
}

function CostScoreCardDepartmentDetailView({
  teams,
  costSummary,
}: CostScoreCardDepartmentDetailViewProps) {
  const teamMappings =
    costSummary?.teams.map(team => ({
      teamNamePortal: team.teamNamePortal,
      teamNameExternal: team.teamNameExternal,
    })) ?? [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <Header exploreCostsUrl={createDatadogUrl(teamMappings)} />
      </Grid>
      <Grid item xs={12} md={12}>
        <InfoCard title="Cost Overspend Across Teams">
          <CostStackedBarChart costSummary={costSummary} teams={teams} />
        </InfoCard>
      </Grid>
    </Grid>
  );
}

export { CostScoreCardDepartmentDetailView };
